import { toast } from 'react-toastify';

import { decode } from 'jsonwebtoken';
import { isArray } from 'lodash';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import { requestTranslate } from '../language/actions';
import {
  signInSuccess,
  signFailure,
  signOut,
  signInSuccessRefressToken,
  signInRefreshToken,
} from './actions';

export function* signInMicrosoft({ payload }) {
  try {
    const { params } = payload;
    const { data } = yield call(api.post, 'logins/loginad', params);
    const decoded = decode(data);
    const obj = JSON.parse(decoded.data);

    const user = {
      id: obj.idusuario,
      name: obj.nomeusuario,
      client: obj.idcliente,
      username: obj.codigousuario,
      nomeperfil: obj.nomeperfil,
      versao: obj.versaosistemausuario,
      apresentacaoteovisualizada: obj.apresentacaoteovisualizada,
    };

    api.defaults.headers.token = data;
    api.defaults.headers.Authorization = `Bearer ${data}`;
    api.defaults.headers.common.Authorization = `Bearer ${data}`;

    sessionStorage.setItem('URL_BACKEND', process.env.REACT_APP_URL_REQUEST);
    sessionStorage.setItem('URL_REPORT', process.env.REACT_APP_URL_DOWNLOAD);

    yield put(
      signInSuccess(data, user, obj.modulos, obj.configgeral, obj.ididioma)
    );
    yield put(requestTranslate());

    history.push('/dashboardvisaogeral');
  } catch (err) {
    if (isArray(err)) err.map((e) => toast.error(t(e)));
    else toast.error(t(err));

    yield put(signFailure());
  }
}

export function* signInRefressToken({ payload }) {
  try {
    const { data } = payload;
    const decoded = decode(data);
    const obj = JSON.parse(decoded.data);

    const user = {
      id: obj.idusuario,
      name: obj.nomeusuario,
      client: obj.idcliente,
      username: obj.codigousuario,
      nomeperfil: obj.nomeperfil,
      versao: obj.versaosistemausuario,
      forcatrocarsenha: obj.forcatrocarsenha,
    };

    api.defaults.headers.token = data;
    api.defaults.headers.Authorization = `Bearer ${data}`;
    api.defaults.headers.common.Authorization = `Bearer ${data}`;

    yield put(
      signInSuccessRefressToken(
        data,
        user,
        obj.modulos,
        obj.configgeral,
        obj.ididioma
      )
    );

    yield put(requestTranslate());
  } catch (err) {
    if (isArray(err)) err.map((e) => toast.error(t(e)));
    else toast.error(t(err));

    yield put(signFailure());
  }
}

export function* signIn({ payload }) {
  try {
    const { data } = payload;
    const decoded = decode(data);
    const obj = JSON.parse(decoded.data);

    const user = {
      id: obj.idusuario,
      name: obj.nomeusuario,
      client: obj.idcliente,
      username: obj.codigousuario,
      nomeperfil: obj.nomeperfil,
      versao: obj.versaosistemausuario,
      forcatrocarsenha: obj.forcatrocarsenha,
      apresentacaoteovisualizada: obj.apresentacaoteovisualizada,
    };

    api.defaults.headers.token = data;
    api.defaults.headers.Authorization = `Bearer ${data}`;
    api.defaults.headers.common.Authorization = `Bearer ${data}`;

    yield put(
      signInSuccess(data, user, obj.modulos, obj.configgeral, obj.ididioma)
    );

    yield put(requestTranslate());
  } catch (err) {
    if (isArray(err)) err.map((e) => toast.error(t(e)));
    else toast.error(t(err));

    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.token = token;
    api.defaults.headers.Authorization = `Bearer ${token}`;
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

export function* signLogOut({ payload }) {
  // Caso tenha interesse de utilizar para passar algum dado adcional vou deixar já a dica!
  try {
    const { token } = api.defaults.headers;
    const { data } = yield call(api.post, 'logins/logout', { token });
  } catch (err) {}

  yield put(signOut());
}

export function signOutD() {
  window.location.reload();
  // history.push('/');
}

export function* signRefreshToken({ payload }) {
  try {
    if (payload) {
      api.defaults.headers.token = payload;
      api.defaults.headers.Authorization = `Bearer ${payload}`;
      api.defaults.headers.common.Authorization = `Bearer ${payload}`;
    }
    // yield put(signInRefreshToken(payload));
  } catch (err) {
    if (isArray(err)) err.map((e) => toast.error(t(e)));
    else toast.error(t(err));

    yield put(signFailure());
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_OUT', signOutD),
  takeLatest('@auth/SIGN_IN_MICROSOFT', signInMicrosoft),
  takeLatest('@auth/SIGN_LOGOUT', signLogOut),
  takeLatest('@auth/SIGN_IN_REQUEST_REFRESSTOKEN', signInRefressToken),
  takeLatest('@auth/SIGN_REFRESHTOKEN', signRefreshToken),
]);
